/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { actionCreatorFactory } from 'typescript-fsa';
import { PlayListEntry } from '../../../services/playlist';

const actionCreator = actionCreatorFactory();

export const SET_PLAYLIST_SEARCH_LIST = 'SET_PLAYLIST_SEARCH_LIST';
export const setPlaylistSearchList = actionCreator<PlayListEntry[]>(SET_PLAYLIST_SEARCH_LIST);

export const SET_PLAYLIST_SEARCH = 'SET_PLAYLIST_SEARCH';
export const setPlaylistSearch = actionCreator<string>(SET_PLAYLIST_SEARCH);

export const SET_PLAYLIST_SEARCH_CURRENT_POS = 'SET_PLAYLIST_SEARCH_CURRENT_POS';
export const setPlaylistSearchCurrentPos = actionCreator<number>(SET_PLAYLIST_SEARCH_CURRENT_POS);

export const SET_PLAYLIST_SEARCH_COUNT = 'SET_PLAYLIST_SEARCH_COUNT';
export const setPlaylistSearchCount = actionCreator<number>(SET_PLAYLIST_SEARCH_COUNT);

export const SEARCH_PLAYLIST = 'SEARCH_PLAYLIST';
export const searchPlaylist = actionCreator(SEARCH_PLAYLIST);

export const PLAYLIST_FORWARD = 'PLAYLIST_FORWARD';
export const playlistForward = actionCreator(PLAYLIST_FORWARD);

export const PLAYLIST_BACKWARD = 'PLAYLIST_BACKWARD';
export const playlistBackward = actionCreator(PLAYLIST_BACKWARD);

export const PLAYLIST_FAST_FORWARD = 'PLAYLIST_FAST_FORWARD';
export const playlistFastForward = actionCreator(PLAYLIST_FAST_FORWARD);

export const PLAYLIST_FAST_BACKWARD = 'PLAYLIST_FAST_BACKWARD';
export const playlistFastBackward = actionCreator(PLAYLIST_FAST_BACKWARD);

export const PLAYLIST_SET_FROM_DATE = 'PLAYLIST_SET_FROM_DATE';
export const setPlaylistFromDate = actionCreator<Date>(PLAYLIST_SET_FROM_DATE);

export const PLAYLIST_SET_TO_DATE = 'PLAYLIST_SET_TO_DATE';
export const setPlaylistToDate = actionCreator<Date>(PLAYLIST_SET_TO_DATE);

export const PLAYLIST_INITIATE_SEARCH = 'PLAYLIST_INITIATE_SEARCH';
export const playlistInitiateSearch = actionCreator<string>(PLAYLIST_INITIATE_SEARCH);

export const PLAYLIST_SET_IS_LOADING = 'PLAYLIST_SET_IS_LOADING';
export const playlistSetIsLoading = actionCreator<boolean>(PLAYLIST_SET_IS_LOADING);

export const PLAYLIST_IMPORT_MUSICBRAINZ_SONG = 'PLAYLIST_IMPORT_MUSICBRAINZ_SONG';
export const playlistImportMusicbrainzSong = actionCreator<string>(PLAYLIST_IMPORT_MUSICBRAINZ_SONG);
